import createWebStorage from 'redux-persist/lib/storage/createWebStorage';

const createNoopStorage = () => {
	return {
		getItem(_key: string) {
			return Promise.resolve(null);
		},
		setItem<T>(_key: string, value: T) {
			return Promise.resolve(value);
		},
		removeItem(_key: string) {
			return Promise.resolve();
		},
	};
};

export const storage =
	typeof window !== 'undefined'
		? createWebStorage('local')
		: createNoopStorage();

export const persistConfig = {
	key: 'root',
	version: 1,
	storage,
	whitelist: ['myPage'],
};
